/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["or",[["à¬ªà­","à¬"],["AM","PM"]],[["AM","PM"],["à¬ªà­à¬°à­à¬¬à¬¾à¬¹à­à¬¨","à¬à¬ªà¬°à¬¾à¬¹à­à¬¨"]],[["à¬°","à¬¸à­","à¬®","à¬¬à­","à¬à­","à¬¶à­","à¬¶"],["à¬°à¬¬à¬¿","à¬¸à­à¬®","à¬®à¬à­à¬à¬³","à¬¬à­à¬§","à¬à­à¬°à­","à¬¶à­à¬à­à¬°","à¬¶à¬¨à¬¿"],["à¬°à¬¬à¬¿à¬¬à¬¾à¬°","à¬¸à­à¬®à¬¬à¬¾à¬°","à¬®à¬à­à¬à¬³à¬¬à¬¾à¬°","à¬¬à­à¬§à¬¬à¬¾à¬°","à¬à­à¬°à­à¬¬à¬¾à¬°","à¬¶à­à¬à­à¬°à¬¬à¬¾à¬°","à¬¶à¬¨à¬¿à¬¬à¬¾à¬°"],["à¬°à¬¬à¬¿","à¬¸à­à¬®","à¬®à¬à­à¬à¬³","à¬¬à­à¬§","à¬à­à¬°à­","à¬¶à­à¬à­à¬°","à¬¶à¬¨à¬¿"]],u,[["à¬à¬¾","à¬«à­","à¬®à¬¾","à¬","à¬®à¬","à¬à­","à¬à­","à¬","à¬¸à­","à¬","à¬¨","à¬¡à¬¿"],["à¬à¬¾à¬¨à­à¬à¬°à­","à¬«à­à¬¬à­à¬à¬°à­","à¬®à¬¾à¬°à­à¬à­à¬","à¬à¬ªà­à¬°à­à¬²","à¬®à¬","à¬à­à¬¨","à¬à­à¬²à¬¾à¬","à¬à¬à¬·à­à¬","à¬¸à­à¬ªà­à¬à­à¬®à­à¬¬à¬°","à¬à¬à­à¬à­à¬¬à¬°","à¬¨à¬­à­à¬®à­à¬¬à¬°","à¬¡à¬¿à¬¸à­à¬®à­à¬¬à¬°"]],u,[["BC","AD"],u,["à¬à­à¬°à­à¬·à­à¬à¬ªà­à¬°à­à¬¬","à¬à­à¬°à­à¬·à­à¬à¬¾à¬¬à­à¬¦"]],0,[0,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE, MMMM d, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##,##0.###","#,##0%","Â¤#,##0.00","#E0"],"INR","â¹","à¬­à¬¾à¬°à¬¤à­à­ à¬à¬à­à¬à¬¾",{"BYN":[u,"Ñ."],"PHP":[u,"â±"]},"ltr", plural];
